import React from "react";

export const CloseIcon: React.FC<{ size?: string | number; style?: React.CSSProperties; className?: string }> = ({
  size = 18,
  style,
  className
}) => {
  const iconSize = typeof size === "number" ? `${size}px` : size;
  return (
    <svg
      width={iconSize}
      height={iconSize}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2.5"
      strokeLinecap="round"
      strokeLinejoin="round"
      style={style}
      className={className}
    >
      <line x1="18" y1="6" x2="6" y2="18" />
      <line x1="6" y1="6" x2="18" y2="18" />
    </svg>
  );
};

export default CloseIcon;
